import { InputText } from "primereact/inputtext";
import { Calendar } from "primereact/calendar";
import { addLocale } from "primereact/api";
import React, { useMemo } from "react";
import { buro1CSS } from "./Buro1.css";
import { Button } from "primereact/button";
import {
  buroPersonaF,
  buroPersonaFE,
  buroPersonaM,
} from "../../../../../Assets/Images";
import { Controller, useForm } from "react-hook-form";
import { estados } from "../../../../../Utils";
import { Dropdown } from "primereact/dropdown";
import { CustomDateInput } from "../CustomDateInput/CustomDateInput";
import axios from "axios";
import { formatDate } from "../functions";
import { url } from "../../../../../env";
import { Loader } from "../../../../../Components";
import { SelectedPerson } from "./components/SelectedPerson";
import { Disclaimer } from "./components/Disclaimer";
import { PersonalData } from "./components/PersonalData";
import { Address } from "./components/Addres";
import { InfoTypePerson } from "./components/InfoTypePerson";

const validateField = (field, message) => {
  if (field === '') {
    return {
      type: 'required',
      message
    };
  }
  return null;
};

const validateEmail = (email, confirmEmail, fieldName) => {
  if (email === '') {
    return {
      type: 'required',
      message: `${fieldName} es requerido`
    };
  }
  if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
    return {
      type: 'invalid',
      message: `Formato de ${fieldName.toLowerCase()} inválido`
    };
  }
  if (confirmEmail && email !== confirmEmail) {
    return {
      type: 'mismatch',
      message: 'Los correos electrónicos no coinciden'
    };
  }
  return null;
};

const customResolver = async (data, typePerson) => {
  const errors = {};
  // Datos personales básicos

  // if(typePerson === 1) {
  // errors.firstName = validateField(data.firstName, 'Nombre es requerido');
  // errors.paternal = validateField(data.paternal, 'Apellido paterno es requerido');
  // errors.maternal = validateField(data.maternal, 'Apellido materno es requerido');
  // }
  // Validación de RFC y fecha de nacimiento
  errors.rfc = validateField(data.rfc, 'RFC es requerido');
  if (data.rfc && data.rfc.length < 12) {
    errors.rfc = {
      type: 'invalid',
      message: 'RFC debe tener al menos 12 caracteres'
    };
  }
  errors.birthday = validateField(data.birthday, 'Fecha de nacimiento es requerida');

  // Dirección
  errors.address = validateField(data.address, 'Dirección es requerida');
  errors.estado = validateField(data.estado, 'Estado es requerido');
  errors.city = validateField(data.city, 'Ciudad es requerida');
  errors.zip = validateField(data.zip, 'Código postal es requerido');
  errors.col = validateField(data.col, 'Colonia es requerida');

  // Validación específica para persona moral
  if (typePerson === 2) {
    errors.isMoralPersonName = validateField(data.isMoralPersonName, 'Nombre de la empresa es requerido');
    errors.isMoralPersonRfc = validateField(data.isMoralPersonRfc, 'RFC de la empresa es requerido');
    errors.isMoralPersonCiec = validateField(data.isMoralPersonCiec, 'CIEC de la empresa es requerido');
    errors.isMoralPersonEmail = validateEmail(data.isMoralPersonEmail, data.isMoralPersonConfirmEmail, 'Correo electrónico de la empresa');
    errors.isMoralPersonConfirmEmail = validateField(data.isMoralPersonConfirmEmail, 'Confirmar correo electrónico de la empresa es requerido');
    errors.fechaConstitucion = validateField(data.fechaConstitucion, 'Fecha de constitución es requerida');
  }

  // Validaciones adicionales
  if (data.zip && !/^\d{5}$/.test(data.zip)) {
    errors.zip = {
      type: 'invalid',
      message: 'Código postal debe tener 5 dígitos'
    };
  }

  // Autorización
  errors.authorization = !data.authorization ? {
    type: 'required',
    message: 'Debe aceptar la autorización'
  } : null;

  return {
    values: data,
    errors: Object.keys(errors).reduce((acc, key) => {
      if (errors[key]) acc[key] = errors[key];
      return acc;
    }, {})
  };
};


function Buro1({ setPage, state, userData, setUserData, setPageStep3, pageStep3, toast }) {
  addLocale("es", {
    firstDayOfWeek: 1,
    dayNames: [
      "domingo",
      "lunes",
      "martes",
      "miércoles",
      "jueves",
      "viernes",
      "sábado",
    ],
    dayNamesShort: ["dom", "lun", "mar", "mié", "jue", "vie", "sáb"],
    dayNamesMin: ["Dom", "Lun", "Mar", "Mié", "Jue", "Vie", "Sáb"],
    monthNames: [
      "enero",
      "febrero",
      "marzo",
      "abril",
      "mayo",
      "junio",
      "julio",
      "agosto",
      "septiembre",
      "octubre",
      "noviembre",
      "diciembre",
    ],
    monthNamesShort: [
      "ene",
      "feb",
      "mar",
      "abr",
      "may",
      "jun",
      "jul",
      "ago",
      "sep",
      "oct",
      "nov",
      "dic",
    ],
    today: "Hoy",
    clear: "Limpiar",
  });


  const lowestYear = useMemo(() => {
    const currentDate = new Date();
    const currentYear = currentDate.getFullYear();
    const dateStr = `${currentYear - 70}-01-01`;
    return new Date(dateStr);
  }, []);

  const greatestYear = useMemo(() => {
    const currentDate = new Date();
    const currentYear = currentDate.getFullYear();
    const dateStr = `${currentYear - 17}-12-31`;
    return new Date(dateStr);
  }, []);

  const defaultVals = {
    // firstName: state?.rodac?.name ? state.rodac.name : "",
    // secondName: "",
    // paternal: state?.rodac?.paterno ? state.rodac.paterno : "",
    // maternal: state?.rodac?.materno ? state.rodac.materno : "",

    email: "",

    birthday: "",
    rfc: "",

    address: "",
    estado: state?.rodac?.estado ? state.rodac.estado : "",
    municipio: state?.rodac?.municipio ? state.rodac.municipio : "",
    zip: state?.rodac?.zip ? state.rodac.zip : "",
    city: state?.rodac?.ciudad ? state.rodac.ciudad : "",
    col: state?.rodac?.colonia ? state.rodac.colonia : "",

    authorization: false,
  };
  const {
    register,
    handleSubmit,
    watch,
    formState: { errors, isValid },
    control,
    setValue,
    getValues,
    reset,
    trigger
  } = useForm({
    defaultValues: defaultVals,
    mode: "onChange"
  });

  // Para debugging

  let errs = Object.keys(errors);

  const [hasErrors, setHasErrors] = React.useState(false);

  const handleErros = async () => {
    const data = getValues();
    const result = await customResolver(data, pageStep3.selectedTypePerson);

    // Si hay errores, actualiza el estado
    setHasErrors(Object.keys(result.errors).length > 0);
  };

  const [loading, setLoading] = React.useState(false);

  function buroRequest(data) {
    if (!data.authorization) return;

    let birthdayArr = data.birthday?.toLocaleDateString('es-MX').split('/');
    let birthday = birthdayArr ? `${birthdayArr[0].padStart(2, '0')}${birthdayArr[1].padStart(2, '0')}${birthdayArr[2]}` : '';

    setLoading(true);

    axios.get(`${url}/api/infoBuro`, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
      params: {
        type: pageStep3.selectedTypePerson === 1 ? "pf" : "pm",
        consulta: {
          persona: {
            domicilios: [
              {
                ciudad: data.city,
                codPais: "MX",
                cp: data.zip,
                delegacionMunicipio: data.municipio,
                direccion1: data.address,
                direccion2: "",
                estado: data.estado,
              },
            ],
            encabezado: {
              clavePais: "MX",
              claveUnidadMonetaria: "MX",
              identificadorBuro: "",
              idioma: "SP",
              numeroReferenciaOperador: "",
              productoRequerido: "007",
              tipoConsulta: "I",
              tipoContrato: "AL",
            },
            nombre: {
              apellidoMaterno: data.maternal,
              apellidoPaterno: data.paternal,
              primerNombre: data.firstName,
              segundoNombre: data.secondName,
              rfc: data.rfc,
              fechaNacimiento: birthday, // opcional
            },
          },
        },
        mode: "BC",

      }
    }).then((res) => {
      setPageStep3(prev => ({ ...prev, completeLeasingInfo: true, isLoggedSyntage: true }));
      setPage(4);
    }).catch((err) => {
      const errorMsg = err.response?.data?.message || 'Hubo un problema al realizar la consulta. Por favor, inténtelo de nuevo.';
      toast.current.show({
        severity: 'error',
        summary: 'Error en consulta de Buró',
        detail: errorMsg,
        life: 5000
      });
    }).finally(() => {
      setLoading(false);
    });

    // axios
    //   .get(`${url}/getTokenBuro`, 
    //   {
    //     headers: {
    //       "Content-Type": "application/json",
    //     },
    //     params: {
    //       type: "pf",
    //     },
    //   })
    //   .then((res) => {
    //     let token = res.data.access_token;

    //     axios
    //       .post(
    //         "https://api.burodecredito.com.mx:4431/devpf/informe-buro/credit-report-api/v1/informe-buro",
    //         {
    //           consulta: {
    //             persona: {
    //               domicilios: [
    //                 {
    //                   ciudad: data.city,
    //                   codPais: "MX",
    //                   cp: data.zip,
    //                   delegacionMunicipio: data.municipio,
    //                   direccion1: data.address,
    //                   direccion2: "",
    //                   estado: data.estado,
    //                 },
    //               ],
    //               encabezado: {
    //                 clavePais: "MX",
    //                 claveUnidadMonetaria: "MX",
    //                 identificadorBuro: "",
    //                 idioma: "SP",
    //                 numeroReferenciaOperador: "",
    //                 productoRequerido: "001",
    //                 tipoConsulta: "I",
    //                 tipoContrato: "AL",
    //               },
    //               nombre: {
    //                 apellidoMaterno: data.maternal,
    //                 apellidoPaterno: data.paternal,
    //                 primerNombre: data.firstName,
    //                 segundoNombre: data.secondName,
    //                 rfc: data.rfc,
    //                 fechaNacimiento: birthday, // opcional
    //               },
    //             },
    //           },
    //         },
    //         {
    //           headers: {
    //             //Authorization: "Bearer b02bdcbe-8332-4b7f-a411-6f0bba2c7f1c" // PM MOCK
    //             Authorization: `Bearer ${token}`, // PF MOCK
    //           },
    //         }
    //       )
    //       .then((res) => {
    //         // console.log(res.data);
    //       })
    //       .catch((err) => {
    //         console.log(err);
    //       });
    //   })
    //   .catch((err) => {
    //     console.log(err);
    //   });
  }

  const submitForm = async (data) => {
    try {

      // Validación antes del envío
      // const result = await handleErros();

      // if (Object.keys(result.errors).length > 0) {
      //   setHasErrors(true);
      //   return;
      // }


      // Si pasa las validaciones, llamamos a buroRequest
      buroRequest(data);

    } catch (error) {
      console.error('Error en el envío:', error);
      toast.current.show({
        severity: 'error',
        summary: 'Error',
        detail: 'Hubo un error al procesar el formulario',
        life: 3000
      });
    }
  };



  return (
    <div css={buro1CSS()}>
      {loading && <Loader />}

      <Button
        label="Regresar"
        className="Green py-3 mt-4"
        onClick={() => {
          setPage(1);
          setPageStep3((prev) => ({
            ...prev,
            selectedMethod: 0,
            selectedTypePerson: 0,
          }));
        }}
      />

      <form onSubmit={handleSubmit(submitForm)} className="Form">
        <div className="Background" />
        <div className="TopText">
          LLena el formulario con tus datos personales
        </div>

        <SelectedPerson
          pageStep3={pageStep3}
          setPageStep3={setPageStep3}
          reset={reset}
        />

        <InfoTypePerson
          typePerson={pageStep3.selectedTypePerson}
          control={control}
          register={register}
          defaultVals={defaultVals}
          setValue={setValue}
          errors={errors} // Pasa el objeto errors completo
          watch={watch}
          trigger={trigger}
        />

        <Disclaimer register={register} errors={errors} control={control} />

        <div className="ButtonWithShadow">
          <Button
            label="Continuar"
            className="Green py-3 my-4 "
            style={{ width: "100% !important", maxWidth: "100% !important" }}
            type="submit"
          //disabled={!canContinue() && !loading}
          // onClick={submitForm}
          />
          <div className="Shadow"></div>
        </div>

      </form>
    </div>
  );
}

export { Buro1 };
